import React from 'react';
import PropTypes from 'prop-types';
import Badge from '../Badge';

const IsValid = ({ value }) => {
  if (value) return <Badge color="success" text="Válido" />;

  return <Badge color="danger" text="No válido" />;
};

IsValid.propTypes = {
  value: PropTypes.bool,
};

IsValid.defaultProps = {
  value: false,
};

export default IsValid;
